<div class="dropdown select-dropdown" (mouseleave)="showDropDown = false">
  <button type="button" class="btn dropdown-toggle" [ngClass]="{ show: showDropDown }" (click)="showDropDown = !showDropDown">
    @if (!selectedOption) {
      <span>{{ name | titlecase }}</span>
    }
    @if (selectedOption) {
      <span>{{ selectedOptionLabel }}</span>
    }
  </button>
  <div class="dropdown-menu" [ngClass]="{ show: showDropDown }" [@openClose]="showDropDown ? 'open' : 'closed'">
    <div class="dropdown-menu__container">
      <ul>
        @for (option of list; track option) {
          <li [ngClass]="{ active: option.checked }">
            <div class="dropdown-item d-flex align-items-center">
              <div class="form-check">
                <input
                  type="radio"
                  class="form-check-input float-none"
                  [name]="name"
                  [id]="option.label"
                  [value]="option.value"
                  [checked]="option.checked"
                  (change)="getSelectedValue(option)"
                />
                <label class="form-check-label" [for]="option.label">
                  {{ option.label }}
                </label>
              </div>
            </div>
          </li>
        }
      </ul>
    </div>
  </div>
</div>
